import t from "@/lang/lang";
import { GSMServiceKind } from "@/services/backend/services/types/kinds";
import { ServiceVariation } from "@/services/backend/omni/servicevariation/types/service-variation";
import {
  OfferSetupChoice,
  OfferSetupDropdownConfig,
} from "../offer/components/offer-setup-dropdown";

/**
 * wrhOfferSetupChoices create a WRH offer with a scope of work of service variation
 * Full-Service, Kauf, or both. labelPrefix precedes every label.
 */
export function wrhOfferSetupChoices(labelPrefix = ""): OfferSetupChoice[] {
  return [
    {
      label: labelPrefix + t("Full-Service"),
      serviceKind: GSMServiceKind.WRH,
      scopeOfWorkServiceVariations: [ServiceVariation.WRHFullService],
    },
    {
      label: labelPrefix + t("Kauf"),
      serviceKind: GSMServiceKind.WRH,
      scopeOfWorkServiceVariations: [ServiceVariation.WRHKauf],
    },
    {
      label: labelPrefix + t("Kombi"),
      serviceKind: GSMServiceKind.WRH,
      scopeOfWorkServiceVariations: [
        ServiceVariation.WRHFullService,
        ServiceVariation.WRHKauf,
      ],
    },
  ];
}

/**
 * wrhOfferSetupDropdownConfig creates a WRH offer, see
 * {@link wrhOfferSetupChoices}.
 */
export const wrhOfferSetupDropdownConfig: OfferSetupDropdownConfig = {
  choices: wrhOfferSetupChoices(),
};
